import { FC, useState } from 'react';

import { ChangePriceSlideout } from 'components/common/ChangePriceSlideout';
import { toaster } from 'components/design-system/Toaster';
import { Listing, SellerLevel, SellerProfile } from 'types';

type EditListingModalProps = {
  closeModal: () => void;
  isOpen?: boolean;
  listing: Listing;
  sellerProfile?: SellerProfile;
  sellerLevels?: SellerLevel[];
  onUpdateListing: (listingId: number, newFields: object) => Promise<Listing>;
};

export const EditListingModal: FC<EditListingModalProps> = ({
  closeModal,
  isOpen,
  listing,
  sellerProfile,
  sellerLevels,
  onUpdateListing
}) => {
  const [currentPrice, setCurrentPrice] = useState<string | undefined>(String(listing.listedPriceCents / 100));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentPriceCents = Number(currentPrice || 0) * 100;
  const isLowerThanMinimalPrice = Number(currentPrice || 0) < 1000;

  const updatePriceModal = async () => {
    try {
      setIsSubmitting(true);
      await onUpdateListing(listing.id, { priceCents: currentPriceCents, listingId: listing.id });
      toaster.success('Price successfully updated');
    } catch (error) {
      console.error(error);
      toaster.error('Updating price failed. Please try again');
    } finally {
      setIsSubmitting(false);
      closeModal();
    }
  };

  const submitBtnProps = {
    onClick: updatePriceModal,
    loading: isSubmitting,
    title: 'Update price',
    disabled: isSubmitting || listing.priceCents === currentPriceCents || isLowerThanMinimalPrice
  };

  return (
    <ChangePriceSlideout
      currentPrice={currentPrice}
      setCurrentPrice={setCurrentPrice}
      sellerLevels={sellerLevels}
      sellerProfile={sellerProfile}
      listing={listing}
      closeModal={closeModal}
      title='Change price'
      submitButton={submitBtnProps}
      isOpen={isOpen}
    />
  );
};
